import { sanitizeTextForAnalytics } from "@/utils/helper"
import {
  VISUAL_SEARCH,
  VISUAL_SEARCH_RESULT,
  NAVIGATION,
  GLOBAL_HEADER,
  FAILURE,
  SUCCESS,
  INCORRECT_EVENT_MESSAGE,
  GLOBAL_NAV,
  SEARCH_RESULT,
  VSEARCH_RESULT,
  SUCCESS_MESASGE,
  FAILURE_MESSAGE,
} from "@/components/GlobalVisualSearch/analytics/constants"

export const addAdobeDataLayerGlobalVisualSearch = analytics => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState && getState("page")

  const {
    event,
    category,
    eventStatus,
    linkUrl,
    eventMsg,
    product,
    productCount,
    visualSearch,
    browse,
    errrorMessage,
    eventShow,
  } = analytics

  const productName_ = product?.title?.text ?? product?.name
  const pdpUrl = product?.pdpUrl
  const links = linkUrl ?? window.location.href
  const imageeventAction = browse
  let eventInfo = {}
  switch (event) {
    case "search_icon_click":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: `${VISUAL_SEARCH}:search using an image`,
        eventMsg: "n/a",
        eventName: `${VISUAL_SEARCH}:search using an image`,
        eventStatus: "n/a",
        eventType: NAVIGATION,
        internalLinkName: "search using an image",
        internalLinkPosition: `${GLOBAL_HEADER}:${VISUAL_SEARCH}`,
        internalLinkType: `${GLOBAL_NAV}:${NAVIGATION}`,
        internalLinkURL: "n/a",
        internalLinkZoneName: VISUAL_SEARCH,
      }
      break
    case "category_selection":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: `${VISUAL_SEARCH}:select your product:${category}`,
        eventMsg: eventMsg ? sanitizeTextForAnalytics(eventMsg) : "n/a",
        eventName: `${VISUAL_SEARCH}:select your product:${category}`,
        eventStatus: eventStatus ?? "n/a",
        eventType: NAVIGATION,
        internalLinkName: category,
        internalLinkPosition: `${GLOBAL_HEADER}:${VISUAL_SEARCH}`,
        internalLinkType: `${GLOBAL_NAV}:${NAVIGATION}`,
        internalLinkURL: "n/a",
        internalLinkZoneName: `${VISUAL_SEARCH}:select your product`,
      }
      break
    case "result_page_error":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: `${VISUAL_SEARCH}:${SEARCH_RESULT}`,
        eventMsg: FAILURE_MESSAGE,
        eventName: `${VISUAL_SEARCH}:${SEARCH_RESULT}`,
        eventStatus: FAILURE,
        eventType: NAVIGATION,
        internalLinkName: VSEARCH_RESULT,
        internalLinkPosition: `${VISUAL_SEARCH_RESULT}:${category}`,
        internalLinkType: VISUAL_SEARCH_RESULT,
        internalLinkURL: links,
        internalLinkZoneName: VISUAL_SEARCH_RESULT,
        searchContentType: VISUAL_SEARCH_RESULT,
        searchResult: productCount,
        searchResultCategory: "products>0",
      }
      break
    case "result_page_success":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: `${VISUAL_SEARCH}:${SEARCH_RESULT}`,
        eventMsg: SUCCESS_MESASGE,
        eventName: `${VISUAL_SEARCH}:${SEARCH_RESULT}`,
        eventStatus: SUCCESS,
        eventType: NAVIGATION,
        internalLinkName: VSEARCH_RESULT,
        internalLinkPosition: `${VISUAL_SEARCH_RESULT}:${category}`,
        internalLinkType: VISUAL_SEARCH_RESULT,
        internalLinkURL: links,
        internalLinkZoneName: VISUAL_SEARCH_RESULT,
        searchContentType: VISUAL_SEARCH,
        searchResult: productCount,
        searchResultCategory: `products>${productCount}`,
      }
      break
    case "resultpdp_page":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: `${VISUAL_SEARCH}:${SEARCH_RESULT}:product navigation`,
        eventMsg: "n/a",
        eventName: `${VISUAL_SEARCH}:${SEARCH_RESULT}:product navigation`,
        eventStatus: "n/a",
        eventType: NAVIGATION,
        internalLinkName: productName_,
        internalLinkPosition: `${VISUAL_SEARCH_RESULT}:${category}`,
        internalLinkType: `${VISUAL_SEARCH_RESULT}:product tiles`,
        internalLinkURL: pdpUrl,
        internalLinkZoneName: `${VISUAL_SEARCH_RESULT}:products:main content area`,
      }
      break
    case "service_parts":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: `${VISUAL_SEARCH}:${SEARCH_RESULT}:service parts`,
        eventMsg: "n/a",
        eventName: `${VISUAL_SEARCH}:${SEARCH_RESULT}:service parts`,
        eventStatus: "n/a",
        eventType: NAVIGATION,
        internalLinkName: "service parts",
        internalLinkPosition: `${VISUAL_SEARCH_RESULT}:${category}`,
        internalLinkType: `${VISUAL_SEARCH_RESULT}:product tiles`,
        internalLinkURL: "n/a",
        internalLinkZoneName: `${VISUAL_SEARCH_RESULT}:products:main content area`,
      }
      break
    case "image_upload":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: `${VISUAL_SEARCH}:${category}:${imageeventAction}`,
        eventMsg: errrorMessage ? errrorMessage : "n/a",
        eventName: `${VISUAL_SEARCH}:${category}:${imageeventAction}`,
        eventStatus: errrorMessage ? FAILURE : SUCCESS,
        eventType: NAVIGATION,
        internalLinkName: imageeventAction,
        internalLinkPosition: `${GLOBAL_HEADER}:${VISUAL_SEARCH}`,
        internalLinkType: `${GLOBAL_NAV}:navigation`,
        internalLinkURL: "n/a",
        internalLinkZoneName: `${VISUAL_SEARCH}:${category}`,
      }
      break
    case "incorrect_match":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: `${VISUAL_SEARCH}:${SEARCH_RESULT}:incorrect match`,
        eventMsg: INCORRECT_EVENT_MESSAGE,
        eventName: `${VISUAL_SEARCH}:${SEARCH_RESULT}:incorrect match`,
        eventStatus: "n/a",
        eventType: NAVIGATION,
        internalLinkName: "incorrect match",
        internalLinkPosition: `${VISUAL_SEARCH_RESULT}:${category}`,
        internalLinkType: `${VISUAL_SEARCH_RESULT}:search:navigation`,
        internalLinkURL: "n/a",
        internalLinkZoneName: VISUAL_SEARCH_RESULT,
        searchContentType: VISUAL_SEARCH,
        searchResult: productCount,
        searchResultCategory: category,
      }
      break
    case "product-color":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: `${VISUAL_SEARCH}:${SEARCH_RESULT}:color selection`,
        eventMsg: "n/a",
        eventName: `${VISUAL_SEARCH}:${SEARCH_RESULT}:color selection`,
        eventStatus: "n/a",
        eventType: NAVIGATION,
        internalLinkName: "color selection",
        internalLinkPosition: `${VISUAL_SEARCH_RESULT}:${category}`,
        internalLinkType: `${VISUAL_SEARCH_RESULT}:color selection`,
        internalLinkURL: "n/a",
        internalLinkZoneName: `${VISUAL_SEARCH_RESULT}:product details`,
      }
      break
    case "new-search":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: VISUAL_SEARCH,
        eventMsg: "n/a",
        eventName: VISUAL_SEARCH,
        eventStatus: "n/a",
        eventType: NAVIGATION,
        internalLinkName: "visual search notification displayed",
        internalLinkPosition: GLOBAL_HEADER,
        internalLinkType: GLOBAL_NAV,
        internalLinkURL: "n/a",
        internalLinkZoneName: GLOBAL_HEADER,
      }
      break
    case "got-it":
      eventInfo = {
        clickInternalLinks: "true",
        eventAction: `${VISUAL_SEARCH}:got it`,
        eventMsg: "n/a",
        eventName: `${VISUAL_SEARCH}:got it`,
        eventStatus: "n/a",
        eventType: NAVIGATION,
        internalLinkName: "got it",
        internalLinkPosition: `${GLOBAL_HEADER}:${VISUAL_SEARCH}`,
        internalLinkType: `${GLOBAL_NAV}:visual search notification`,
        internalLinkURL: "n/a",
        internalLinkZoneName: VISUAL_SEARCH,
      }
      break
  }

  const productInfo = product ? getAnalyticProductInfo(product, category) : null
  if (visualSearch) productInfo.visualSearch = true

  if (eventShow) {
    const cmpShowEvent = window.adobeDataLayer.find(
      e => e?.event === "cmp:show"
    )
    if (cmpShowEvent) {
      cmpShowEvent.eventInfo = eventInfo
      cmpShowEvent.page.pageInfo["pageName"] = `kohler:${VISUAL_SEARCH}`
      cmpShowEvent.page.pageInfo["title"] = "Visual Search | KOHLER"
    }
  } else {
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo,
      page,
      ...(productInfo != null && { productInfo }),
    })
  }
}

const priceNumber = priceString => {
  return parseFloat(priceString?.replace(/[^\d.-]/g, ""))
}
const getAnalyticProductInfo = (products, category) => {
  const productSKU = products?.productDetails?.SKU?.text ?? products?.sku
  const productPrice = priceNumber(products?.price?.text || products?.priceing)

  const productInfo = {
    category: category,
    defaultImageName: products?.image?.src ?? products?.isoImageURL,
    description: sanitizeTextForAnalytics(
      products?.description?.text ?? products?.longDescription
    ),
    frequency: "n/a",
    globalDiscount: "n/a",
    globalOffer: "n/a",
    globalPromotionPrice: "n/a",
    isRecommended: "n/a",
    isSendNow: "n/a",
    isSubscription: "n/a",
    itemType: sanitizeTextForAnalytics(category),
    numberOfReviews: "n/a",
    pdpType: "regular finished goods",
    priceState: "regular price",
    productBasePrice: productPrice,
    productBrand: "kohler",
    productCategory: sanitizeTextForAnalytics(category),
    productCollectionsName: products?.title?.text ?? products?.name,
    productColor: products?.productColor ?? "n/a",
    productCouponCode: "n/a",
    productCoupondiscount: "n/a",
    productFindingMethod: "n/a",
    productID: `K-${productSKU}`,
    productName: sanitizeTextForAnalytics(
      products?.title?.text ?? products?.name
    ),
    productPartnerBuyNow: "n/a",
    productRoom: "n/a",
    productSalePrice: productPrice,
    productSaleable: "n/a",
    productStatus: "n/a",
    productSuperSku: "n/a",
    productTileName: sanitizeTextForAnalytics(products?.description?.text),
    quantity: "n/a",
    ratings: "n/a",
    visualSearch: true,
  }
  return productInfo
}
